import { getGlobalClassNames } from '../../Styling';
var GlobalClassNames = {
    root: 'ms-TooltipHost'
};
export var getStyles = function (props) {
    var className = props.className, theme = props.theme;
    var classNames = getGlobalClassNames(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                display: 'inline'
            },
            className
        ]
    };
};
//# sourceMappingURL=TooltipHost.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/Tooltip/TooltipHost.styles.js
// module id = 725
// module chunks = 0